<!-- contractor-report.vue -->
<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <qesg-dash-table-card class="h-100" icon="table" title="">
                    <template v-slot:title>
                        <h5 class="d-inline-block font-weight-normal mb-0 mr-2">
                            <span class="text-secondary">{{ $t('기업별 평가결과 현황') }}</span>
                            <b-badge variant="info" class="text-white ml-2" pill>
                                <small>{{ $t('표시 {shown} / 전체 {total}', {shown: filteredResultHistory.length, total: result_history.length}) }}</small>
                            </b-badge>
                        </h5>
                    </template>

                    <b-row no-gutters class="border-top border-bottom border-color-gray-300 py-3 px-3">
                        <b-col cols="6" md="6" xl="4">
                            <b-input-group>
                                <b-form-input v-model="company_name_input"
                                    :title="$t('참여기업 이름 검색')"
                                    :aria-label="$t('참여기업 이름 검색')"
                                    :placeholder="$t('참여기업 이름을 입력해주세요')"
                                    :disabled="client_report_global_disabled"
                                    trim
                                    @keyup.enter="applyReportFilter()"
                                    />
                                <b-input-group-append>
                                    <b-btn
                                        :title="$t('참여기업 이름 검색')"
                                        :aria-label="$t('참여기업 이름 검색')"
                                        :disabled="client_report_global_disabled"
                                        @click="applyReportFilter()"
                                        >
                                        <BIconSearch />
                                    </b-btn>
                                    <b-btn
                                        variant="light"
                                        class="border"
                                        :disabled="client_report_global_disabled"
                                        :title="$t('조건 검색')"
                                        :aria-label="$t('조건 검색')"
                                        :aria-expanded="reportFilterOpen ? 'true' : 'false'"
                                        aria-controls="collapse-report-table-filter-form"
                                        @click="reportFilterOpen = !reportFilterOpen"
                                        >
                                        <B-Icon-filter variant="" />
                                    </b-btn>
                                    <b-btn
                                        variant="light"
                                        class="border"
                                        :disabled="client_report_global_disabled"
                                        :title="$t('검색 초기화')"
                                        :aria-label="$t('검색 초기화')"
                                        @click="resetReportFilter"
                                        >
                                        <b-icon-arrow-repeat />
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6" md="6" xl="8">
                            <div class="d-flex justify-content-end align-items-center">
                                <b-form-select
                                    :value="listQuery.perPage"
                                    :options="reportTablePerPageOpt"
                                    :disabled="client_report_global_disabled"
                                    :aria-label="$t('표시 개수')"
                                    class="w-auto"
                                    @change="perPage => navigateList({perPage})"
                                    />
                            </div>
                        </b-col>
                    </b-row>
                    <b-collapse id="collapse-report-table-filter-form" v-model="reportFilterOpen">
                        <b-row>
                            <b-col cols="12">
                                <div class="border bg-light rounded p-3 m-3">
                                    <b-row>
                                        <b-col cols="6" lg>
                                            <b-form-group
                                                id="fieldset-input-report-companyName"
                                                :label="$t('기업명')"
                                                label-for="input-report-companyName"
                                                >
                                                <b-form-input id="input-report-companyName"
                                                    v-model="company_name_input"
                                                    :disabled="client_report_global_disabled"
                                                    trim
                                                    @keyup.enter="applyReportFilter()"
                                                    />
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="6" lg="2">
                                            <b-form-group
                                                id="fieldset-input-report-statusType"
                                                :label="$t('평가유형')"
                                                label-for="input-report-statusType"
                                                >
                                                <b-form-select id="input-report-statusType"
                                                    :value="listQuery.filters.service_type"
                                                    :text-field="`text_${$i18n.locale}`"
                                                    :options="[
                                                        { text_ko: '-- 전체보기 --', text_en: '-- View All --', text_ca: '-- 查看全部 --', value: null },
                                                        { text_ko: '서면평가', text_en: 'On-Desk Assessment', text_ca: '书面评估', value: '일반' },
                                                        { text_ko: '실사평가', text_en: 'On-Site Assessment', text_ca: '实地评估', value: '심화' },
                                                    ]"
                                                    :disabled="client_report_global_disabled"
                                                    @change="value => applyReportFilter({service_type: value})"
                                                    >
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="6" lg="2">
                                            <b-form-group
                                                id="fieldset-input-report-statusCode"
                                                :label="$t('평가상태')"
                                                label-for="input-report-statusCode"
                                                >
                                                <b-form-select id="input-report-statusCode"
                                                    :value="listQuery.filters.status_code"
                                                    :text-field="`text_${$i18n.locale}`"
                                                    :options="status_code_opts"
                                                    :disabled="client_report_global_disabled"
                                                    @change="value => applyReportFilter({status_code: value})"
                                                    >
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="6" lg="2">
                                            <b-form-group
                                                id="fieldset-input-report-reportType"
                                                :label="$t('결과보고서 유형')"
                                                label-for="input-report-reportType"
                                                >
                                                <b-form-select id="input-report-reportType"
                                                    :value="listQuery.filters.report_type"
                                                    :text-field="`text_${$i18n.locale}`"
                                                    :options="[
                                                        { text_ko: '-- 전체보기 --', text_en: '-- View All --', text_ca: '-- 查看全部 --', value: null },
                                                        { text_ko: '서면평가 결과보고서', text_en: 'On-desk Assessment Report', text_ca: '书面评估报告', value: 'report_doc' },
                                                        { text_ko: '실사평가 결과보고서', text_en: 'On-site Assessment Report', text_ca: '实地评估报告', value: 'report_osis' },
                                                    ]"
                                                    :disabled="client_report_global_disabled"
                                                    @change="value => applyReportFilter({report_type: value})"
                                                    >
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>
                    </b-collapse>
                    <b-row v-if="ecovadis_load_error" no-gutters class="mb-2">
                        <b-col cols="12">
                            <b-alert show variant="warning" class="mb-0">
                                {{ $t('에코바디스 기업 정보를 불러오지 못했습니다. 목록에 에코바디스 기업이 포함되어 있을 수 있습니다.') }}
                            </b-alert>
                        </b-col>
                    </b-row>
                    <div v-else-if="ecovadisCount" class="small text-muted px-3 py-2">
                        {{ $t('에코바디스 평가로 대체한 {n}개 기업은 이 목록에서 제외됩니다.', {n: ecovadisCount}) }}
                    </div>
                    <b-row no-gutters class="mb-1">
                        <b-col cols="12">
                            <b-table id="result-table"
                                :items="filteredResultHistory"
                                :per-page="listQuery.perPage"
                                :current-page="listQuery.currentPage"
                                :fields="result_history_fields"
                                class="border-bottom"
                                :busy="is_loading_result_history"
                                show-empty
                                responsive
                                >

                                <template #table-busy>
                                    <div class="text-center my-3">
                                        <b-spinner class="align-middle mr-3"></b-spinner>
                                        <strong>{{ $t('불러오는 중') }}</strong>
                                    </div>
                                </template>

                                <!-- 조회 실패 / 공개된 보고서 없음 / 조건에 맞는 기업 없음을 구분한다 -->
                                <template #empty>
                                    <div v-if="result_history_loaded" class="text-center my-4">
                                        <template v-if="load_error">
                                            <h6 class="text-danger">{{ $t('결과보고서 목록을 불러오지 못했습니다.') }}</h6>
                                            <b-btn size="sm" variant="outline-secondary" @click="getProjectReport()">{{ $t('다시 시도') }}</b-btn>
                                        </template>
                                        <h6 v-else-if="!result_history.length" class="gray-500 mb-0">{{ $t('결과보고서가 공개된 기업이 없습니다.') }}</h6>
                                        <template v-else>
                                            <h6 class="gray-500">{{ $t('조건에 맞는 기업이 없습니다.') }}</h6>
                                            <b-btn size="sm" variant="outline-secondary" @click="resetReportFilter">{{ $t('검색 초기화') }}</b-btn>
                                        </template>
                                    </div>
                                </template>

                                <template #cell(index)="data">
                                    {{ (listQuery.currentPage - 1) * listQuery.perPage + data.index + 1 }}
                                </template>

                                <template #cell(company_name)="data">
                                    {{ data.value }}
                                </template>

                                <template #cell(status_code)="data">
                                    <div class="d-inline px-2 py-1 rounded-pill small"
                                        :style="[{backgroundColor: stats.colors[statsLabel_eng[data.value]], color: statsTextColors[statsLabel_eng[data.value]] || '#fff'}]"
                                        >
                                        {{ status_code_lang[data.value] }}
                                    </div>
                                </template>

                                <template #cell(report_doc)="data">
                                    <template v-if="data.item.status_code === 'requested'">
                                        <span class="f-85 gray-500">{{ $t('미시작') }}</span>
                                    </template>
                                    <template v-else-if="data.item.status_code === 'canceled'">
                                        <span class="f-85 gray-500">{{ $t('평가 취소') }}</span>
                                    </template>
                                    <template v-else-if="!data.item.report_doc && data.item.status_code === 'completed'">
                                        <span class="f-85 gray-500">{{ $t('결과보고서 준비 중') }}</span>
                                    </template>
                                    <template v-else-if="!data.item.report_doc">
                                        <span class="f-85 gray-500">{{ $t('답변 및 평가 진행중') }}</span>
                                    </template>
                                    <template v-else>
                                        <b-btn-group>
                                            <b-btn size="sm" variant="info" :disabled="client_report_global_disabled"
                                                @click="viewReport(data.item, 'doc')"
                                                >
                                                <div class="d-flex align-items-center">
                                                    {{ $t('보기') }}
                                                    <template v-if="is_viewing_report && view_target_report?.company_id === data.item.company_id && view_target_report?.report_type === 'doc'">
                                                        <b-spinner class="ml-2" style="width: 0.9rem;height: 0.9rem;" />
                                                    </template>
                                                    <template v-else>
                                                        <BIconEye class="ml-2" font-scale="0.9" />
                                                    </template>
                                                </div>
                                            </b-btn>
                                            <!-- <b-btn size="sm" variant="primary"
                                                @click="downloadReport(data.item, data.item.company_id, 'doc')"
                                                :disabled="client_report_global_disabled"
                                                >
                                                <div class="d-flex align-items-center">
                                                    {{ $t('다운로드') }}
                                                    <template v-if="download_target_report.company_id == data.item.company_id && download_target_report.type == 'doc'">
                                                        <b-spinner class="ml-2" style="width: 0.9rem;height: 0.9rem;" />
                                                    </template>
                                                    <template v-else>
                                                        <BIconDownload class="ml-2" font-scale="0.9" />
                                                    </template>
                                                </div>
                                            </b-btn> -->
                                        </b-btn-group>
                                    </template>
                                </template>

                                <template #cell(report_osis)="data">
                                    <template v-if="data.item.status_code === 'requested'">
                                        <span class="f-85 gray-500">{{ $t('미시작') }}</span>
                                    </template>
                                    <template v-else-if="data.item.status_code === 'canceled'">
                                        <span class="f-85 gray-500">{{ $t('평가 취소') }}</span>
                                    </template>
                                    <template v-else-if="data.item.service_type === '일반'">
                                        <span class="f-85 gray-500">
                                            {{ $t('실사평가 비대상') }}
                                        </span>
                                    </template>
                                    <template v-else-if="!data.item.report_osis && data.item.status_code === 'completed'">
                                        <span class="f-85 gray-500">{{ $t('결과보고서 준비 중') }}</span>
                                    </template>
                                    <template v-else-if="!data.item.report_osis">
                                        <span class="f-85 gray-500">{{ $t('답변 및 평가 진행중') }}</span>
                                    </template>
                                    <template v-else>
                                        <b-btn-group>
                                            <b-btn size="sm" variant="info" :disabled="client_report_global_disabled"
                                                @click="viewReport(data.item, 'osis')"
                                                >
                                                <div class="d-flex align-items-center">
                                                    {{ $t('보기') }}
                                                    <template v-if="is_viewing_report && view_target_report?.company_id === data.item.company_id && view_target_report?.report_type === 'osis'">
                                                        <b-spinner class="ml-2" style="width: 0.9rem;height: 0.9rem;" />
                                                    </template>
                                                    <template v-else>
                                                        <BIconEye class="ml-2" font-scale="0.9" />
                                                    </template>
                                                </div>
                                            </b-btn>
                                            <!-- <b-btn size="sm" variant="primary"
                                                @click="downloadReport(data.item, data.item.company_id, 'osis')"
                                                :disabled="client_report_global_disabled"
                                                >
                                                <div class="d-flex align-items-center">
                                                    {{ $t('다운로드') }}
                                                    <template v-if="download_target_report.company_id === data.item.company_id && download_target_report.type === 'osis'">
                                                        <b-spinner class="ml-2" style="width: 0.9rem;height: 0.9rem;" />
                                                    </template>
                                                    <template v-else>
                                                        <BIconDownload class="ml-2" font-scale="0.9" />
                                                    </template>
                                                </div>
                                            </b-btn> -->
                                        </b-btn-group>
                                    </template>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col cols="12">
                            <!-- 목록·표시 개수가 바뀌면 다시 만든다: one-way :value 라 b-pagination 내부 보정(빈 목록에서 1페이지)이 URL 페이지와 어긋나지 않게 -->
                            <b-pagination
                                :key="`${filteredResultHistory.length}-${listQuery.perPage}`"
                                :value="listQuery.currentPage"
                                aria-controls="result-table"
                                :total-rows="filteredResultHistory.length"
                                :per-page="listQuery.perPage"
                                :disabled="is_loading_result_history"
                                class="mr-2 mb-0"
                                align="center"
                                @change="page => navigateList({currentPage: page})"
                            >
                            </b-pagination>
                        </b-col>
                    </b-row>
                </qesg-dash-table-card>
            </b-col>
        </b-row>

        <b-modal id="modal-report-viewer" :title="reportModalTitle" size="xxl"
            hide-footer
            body-bg-variant="white"
            scrollable
            centered
            @hide="onHideReportViewer"
            @hidden="onHiddenRerportViewer"
            >
            <b-tabs :value="reportTabIndex"
                content-class="bg-white border-left border-right border-bottom"
                nav-class="h5 mb-0"
                @input="onReportTabInput"
                >
                <b-tab :title="$t('결과보고서 보기')" title-link-class="gray-500 fw-500">
                    <div class="p-3">
                        <ReportViewerContainer
                            v-if="view_target_report"
                            :key="`${view_target_report.project_code}-${view_target_report.company_id}-${view_target_report.report_type}-${view_target_report.report.report_history_id}`"
                            :view_target_report="view_target_report"
                            :view="true"
                            :report_lang="$i18n.locale"
                            />
                    </div>
                </b-tab>
                <b-tab :title="$t('답변보기')" title-link-class="gray-500 fw-500">
                    <!-- md 이상은 문항·답변이 각자 스크롤(모달 본문은 스크롤되지 않는 높이), md 미만은 세로로 쌓고 모달 본문 하나만 스크롤 -->
                    <b-row no-gutters>
                        <b-col cols="12" md="4" class="border-right">
                            <div class="border-bottom border-gray300 py-2 px-3">
                                <h5 class="gray-500 mb-0">{{ $t('문항') }}</h5>
                            </div>
                            <div class="report-answer-pane bgray-100 pl-3 pr-2 py-2">
                                <audit-question-list route-driven @reset-sub-evaluation="loadQuestionFromRoute"></audit-question-list>
                            </div>
                        </b-col>
                        <b-col cols="12" md="8">
                            <div ref="answerPanel" class="position-relative evaluation-panel-1 h-100">
                                <div class="d-flex align-items-center border-bottom border-gray300 pb-2 pt-2 px-3">
                                    <h5 class="gray-500 mr-auto mb-0">
                                        {{ $t('답변') }}
                                        <small v-if="currentQuestionName" class="ml-2">{{ currentQuestionName }}</small>
                                    </h5>

                                    <DropdownLanguage size="sm" class="mr-2" :disabled="client_report_global_disabled" />
                                    <template v-if="is_admin === 4">
                                        <AuditPrintButton
                                            btn_variant="subtop"
                                            size="sm"
                                            >
                                            {{ $t('답변 전체 인쇄/다운로드')}}

                                            <fa icon="print" class="ml-2"></fa>
                                        </AuditPrintButton>
                                    </template>
                                </div>
                                <template v-if="!$route.query.question_code">
                                    <div class="d-flex align-items-center justify-content-center text-center bgray-200 rounded py-5 px-3">
                                        {{ $t('문항 목록에서 문항을 선택하면 협력사의 답변이 표시됩니다.') }}
                                    </div>
                                </template>
                                <template v-else-if="subs_load_error">
                                    <div class="d-flex flex-column align-items-center justify-content-center text-center py-5">
                                        <h6 class="text-danger">{{ $t('답변을 불러오지 못했습니다.') }}</h6>
                                        <b-btn size="sm" variant="outline-secondary" @click="loadQuestionFromRoute">{{ $t('다시 시도') }}</b-btn>
                                    </div>
                                </template>
                                <template v-else-if="subs_loaded">
                                    <div v-if="!subs.length" class="d-flex align-items-center justify-content-center bgray-200 rounded py-5">
                                        {{ $t('이 문항에는 표시할 답변이 없습니다.') }}
                                    </div>
                                    <div v-else class="report-answer-pane px-3 pt-2" style="overflow-x: hidden;">
                                        <sub-component v-for="(sub, sub_idx) in subs" :key="`sub-${sub_idx}-${sub.sub_code}`"
                                            :ref="sub.sub_code"
                                            :sub_type="sub.sub_type"
                                            :item="sub"
                                            :is_disabled_by_parent="true"
                                            :audit_mode="false"
                                            />
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="text-center py-5">
                                        <b-spinner class="gray-500"></b-spinner>
                                    </div>
                                </template>
                            </div>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        </b-modal>
    </b-container>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import { BIconArrowRepeat, BIconFilter, BIconSearch } from 'bootstrap-vue';
import AssessmentCommonMixin from '@shared_mixins/assessment.common.mixin.js';
import initializeDataProgress from '@shared_mixins/contractor-dashboard/initialize-data-progress';
import {
    readContractorListQuery, buildContractorListQuery, isSameQuery, hasListFilters
} from '@shared_mixins/contractor-dashboard/contractor-list-query';
import ReportViewerContainer from '@shared_components/admin/components/report/ReportViewerContainer.vue';
import AuditQuestionList from '@shared_components/admin/components/audit/AuditQuestionList.vue';
import AuditPrintButton from '@shared_components/admin/components/common/AuditPrintButton';
import DropdownLanguage from '@shared_components/utils/dropdown-language';
import QesgDashTableCard from '@shared_components/contractor/components/qesg-dash-table-card.vue';
import subComponent from '@core_components/admin/components/subs/SubComponent.vue';

// URL 에 남기는 목록 상태 (?company_name&service_type&status_code&report_type&current_page&per_page)
const REPORT_LIST_SPEC = Object.freeze({
    fields: {
        company_name: 'string',
        service_type: {type: 'string', values: ['일반', '심화']},
        status_code: {type: 'string', values: ['not_requested', 'requested', 'in_progress', 're_progress', 'in_assessment', 'completed', 'canceled']},
        report_type: {type: 'string', values: ['report_doc', 'report_osis']}
    },
    perPageOptions: [10, 20, 30, 40, 50],
    defaultPerPage: 20
});
// 결과보고서 뷰어가 쓰는 query. 뷰어를 닫으면 이 키만 지우고 목록 상태는 남긴다 (pc·cmp·cpn·cpnm 은 답변보기 하위 컴포넌트가 읽는다)
const VIEWER_QUERY_KEYS = ['report', 'rtype', 'tab', 'question_code', 'pc', 'cmp', 'cpn', 'cpnm'];

export default {
    name: 'ContractorReport',
    props: {
        loadedRequiredData: {
            required: true,
            type: Boolean
        }
    },
    mixins: [
        initializeDataProgress,
        AssessmentCommonMixin
    ],
    components: {
        AuditPrintButton,
        BIconArrowRepeat,
        BIconFilter,
        BIconSearch,
        ReportViewerContainer,
        AuditQuestionList,
        DropdownLanguage,
        QesgDashTableCard,
        subComponent
    },
    data() {
        return {
            is_loading_result_history: false,
            result_history: [],
            load_error: false,
            // 프로젝트 전환·뒤로가기로 늦게 도착한 이전 응답을 버린다
            report_request_seq: 0,

            // download
            download_target_report: {
                company_id: null,
                type: null // doc, osis
            },

            // view
            is_viewing_report: false,
            result_history_loaded: false,
            ecovadis_load_error: false,
            // 프로젝트별 에코바디스 대체 기업 { [projectid]: { [company_id]: true } } — 빈 결과도 조회 완료로 남긴다
            ecovadis_by_project: {},
            subs_load_error: false,
            view_target_report: null,
            // 닫히는 중인 뷰어(hidden 에서 이 뷰어만 정리한다)
            closing_report: null,
            closing_navigation: null,
            // 문항은 한 번에 하나씩 불러오고, 그 사이 바뀐 URL 은 끝난 뒤 한 번 더 반영한다
            question_loading: false,
            question_reload: false,

            // search condition — 입력 중인 기업명(Enter·검색 버튼으로 적용). 적용된 조건은 URL(listQuery)
            company_name_input: null,
            reportFilterOpen: false,
            status_code_opts: [
                { text_ko: '-- 전체보기 --', text_en: '-- View All --', text_ca: '-- 查看全部 --', value: null },
                { text_ko: '미신청', text_en: 'Not Applied', text_ca: '未申请', value: 'not_requested' },
                { text_ko: '신청함', text_en: 'Applied', text_ca: '已申请', value: 'requested' },
                { text_ko: '답변중', text_en: 'In Progress', text_ca: '进行中', value: 'in_progress' },
                { text_ko: '보완중', text_en: 'Re-Progress', text_ca: '修订中', value: 're_progress' },
                { text_ko: '평가중', text_en: 'In Assessment', text_ca: '评估中', value: 'in_assessment' },
                { text_ko: '완료됨', text_en: 'Completed', text_ca: '已完成', value: 'completed' },
                { text_ko: '취소됨', text_en: 'Canceled', text_ca: '已取消', value: 'canceled' },
            ],
            status_code_ko: {
                not_requested: '미신청',
                requested: '신청함',
                in_progress: '답변중',
                re_progress: '보완중',
                in_assessment: '평가중',
                completed: '완료됨',
                canceled: '취소됨',
            },
            status_code_en: {
                not_requested: 'Not Applied',
                requested: 'Applied',
                in_progress: 'In Progress',
                re_progress: 'Re-Progress',
                in_assessment: 'In Assessment',
                completed: 'Completed',
                canceled: 'Canceled',
            },
            status_code_ca: {
                not_requested: '未申请',
                requested: '已申请',
                in_progress: '进行中',
                re_progress: '修订中',
                in_assessment: '评估中',
                completed: '已完成',
                canceled: '已取消',
            },

            // Viewer
            reportPDFLoadProgress: 0,
            reportPDFLoaded: false,

            // 보고서 언어 - report_lang (report.hmc.mixin.js 에 있음) 변경시 언어 지원 결과보고서 미리보기용 데이터
            pdf_filename: null,
            reportMode: 'full',
            needReport: false,
            reportData: { info: null, benchmarks: null, parser: null, risk: null, scoring: null },

            // 기업 답변 관련 데이터
            answer_audit_mode: 'evaluation',

            lang_pattern: /(KOR|CHI|ENG)/g,
            lang_pattern_pair: { KOR: 'ko', CHI: 'ca', ENG: 'en' },
            lang_pattern_reverse_pair: { ko: 'KOR', ca: 'CHI', en: 'ENG' },
        };
    },
    computed: {
        // 기업 답변 관련 데이터
        ...mapState(['question_composition', 'is_admin']),
        ...mapState('questions', ['subs', 'answer_company', 'subs_loaded']),
        listQuery () {
            return readContractorListQuery(this.$route.query, REPORT_LIST_SPEC);
        },
        // 한 번 받은 목록을 URL 조건으로 거른다
        filteredResultHistory () {
            const { company_name, service_type, status_code, report_type } = this.listQuery.filters;
            const _name = company_name?.toLowerCase();
            return this.result_history.filter(item => (!_name || (item.company_name || '').toLowerCase().includes(_name))
                && (!service_type || item.service_type === service_type)
                && (!status_code || item.status_code === status_code)
                && (!report_type || !!item[report_type]));
        },
        // 조회가 끝난 목록보다 URL 페이지가 크면(데이터가 줄었거나 주소를 직접 고친 경우) 1페이지로 보정한다
        listPageOverflow () {
            if (!this.result_history_loaded || this.is_loading_result_history || this.load_error) return false;
            return this.listQuery.currentPage > Math.max(1, Math.ceil(this.filteredResultHistory.length / this.listQuery.perPage));
        },
        ecovadisCount () {
            return Object.keys(this.ecovadis_by_project[this.$route.query.projectid] || {}).length;
        },
        reportTabIndex () {
            return this.$route.query.tab === 'answers' ? 1 : 0;
        },
        reportModalTitle () {
            return this.view_target_report?.company_name
                ? `${this.$t('결과보고서 보기')} - ${this.view_target_report.company_name}`
                : this.$t('결과보고서 보기');
        },
        // 지금 URL 의 문항이 불러와졌을 때만 문항명을 보여준다
        currentQuestionName () {
            const _composition = this.question_composition;
            if (!_composition?.question_code || String(_composition.question_code) !== String(this.$route.query.question_code || '')) return '';
            return this.showTranslation(_composition.question_name, _composition.question_name_e, _composition.question_name_c) || _composition.question_name;
        },
        result_history_fields(){
            return [
                {
                    key: 'index',
                    label: this.$t('번호'),
                    thStyle: [
                        { width: '7%' },
                        { textAlign: 'center'}
                    ],
                    tdClass: ['text-center', 'align-middle']
                },
                {
                    key: 'company_name',
                    label: this.$t('기업명'),
                    thClass: ['text-center', 'align-middle'],
                    sortable: true
                },
                {
                    key: 'service_type',
                    label: this.$t('평가 유형'),
                    thStyle: [
                        { width: '12.5%' },
                        { textAlign: 'center' }
                    ],
                    tdClass: ['text-center', 'align-middle'],
                    formatter: value => this.$t(value === '일반' ? '서면평가' : '실사평가'),
                    sortable: true,
                    sortByFormatted: true
                },
                {
                    key: 'status_code',
                    label: this.$t('평가 상태'),
                    thStyle: [
                        { width: '12.5%' },
                        { textAlign: 'center' }
                    ],
                    tdClass: ['text-center', 'align-middle'],
                    sortable: true
                },
                {
                    key: 'report_doc',
                    label: this.$t('서면평가 결과보고서'),
                    thStyle: [
                        { width: '20%' },
                        { textAlign: 'center' }
                    ],
                    tdClass: ['text-center', 'align-middle']
                },
                {
                    key: 'report_osis',
                    label: this.$t('실사평가 결과보고서'),
                    thStyle: [
                        { width: '20%' },
                        { textAlign: 'center' }
                    ],
                    tdClass: ['text-center', 'align-middle']
                }
            ];
        },

        // 결과보고서 관련 데이터
        client_report_global_disabled () {
            return this.is_loading_result_history
                || this.is_viewing_report
                || this.download_target_report.company_id !== null
                || !this.loadedRequiredData;
        },
        status_code_lang () {
            return this.$i18n.locale === 'ko'
                ? this.status_code_ko
                : this.$i18n.locale === 'en'
                    ? this.status_code_en
                    : this.status_code_ca;
        },
        reportTablePerPageOpt () {
            if (this.$i18n.locale === 'ko') {
                return [
                    { text: '10개씩 보기', value: 10 },
                    { text: '20개씩 보기', value: 20 },
                    { text: '30개씩 보기', value: 30 },
                    { text: '40개씩 보기', value: 40 },
                    { text: '50개씩 보기', value: 50 },
                ];
            } else if (this.$i18n.locale === 'en') {
                return [
                    { text: 'View 10 per page', value: 10 },
                    { text: 'View 20 per page', value: 20 },
                    { text: 'View 30 per page', value: 30 },
                    { text: 'View 40 per page', value: 40 },
                    { text: 'View 50 per page', value: 50 }
                ];
            } else {
                return [
                    { text: '每页显示 10条', value: 10 },
                    { text: '每页显示 20条', value: 20 },
                    { text: '每页显示 30条', value: 30 },
                    { text: '每页显示 40条', value: 40 },
                    { text: '每页显示 50条', value: 50 }
                ];
            }
        },
    },
    watch: {
        loadedRequiredData: {
            async handler (_state, _old_state) {
                if (_state && !_old_state) {
                    // await this.addFontVFS();
                    await this.getProjectReport();
                }
            }
        },
        // 프로젝트 전환은 상단바가 {projectid} 만 push 하므로 목록 조건·페이지·표시 개수는 URL 에서 함께 빠진다
        async '$route.query.projectid' (_updated_project_id) {
            // 초기화
            this.result_history = [];
            this.result_history_loaded = false;
            this.load_error = false;
            this.reportFilterOpen = false;
            this.download_target_report = {
                company_id: null,
                type: null // doc, osis
            };
            this.view_target_report = null;
            if (!_updated_project_id || !this.loadedRequiredData) return;
            await this.getProjectReport();
        },
        // 입력만 하고 적용하지 않은 기업명은 페이지 이동·뒤로가기 때 URL 값으로 되돌린다
        '$route.query' () {
            this.company_name_input = this.listQuery.filters.company_name;
        },
        listPageOverflow (_overflow) {
            if (_overflow) this.navigateList({currentPage: 1}, 'replace');
        },
        '$i18n.locale': {
            immediate: true,
            handler(_i18n_lang) {
                this.report_lang = _i18n_lang;
            }
        },
        '$route.query.report' () {
            this.syncReportViewer();
        },
        '$route.query.rtype' () {
            this.syncReportViewer();
        },
        '$route.query.question_code' (_code) {
            this.loadQuestionFromRoute();
            // md 미만은 문항 목록 아래에 답변이 쌓이므로 고른 문항의 답변 쪽으로 내려 준다
            if (_code && window.matchMedia('(max-width: 767.98px)').matches) {
                this.$nextTick(() => this.$refs.answerPanel?.scrollIntoView({ block: 'start' }));
            }
        },
        answer_company: {
            async handler (_answer_company) {
                this.initAttachmentsStorage();

                if (_answer_company.campaign_id && _answer_company.company_id) {
                    await this.getAttatchments({ campaign_id: _answer_company.campaign_id, company_id: _answer_company.company_id });
                }
            }
        }
    },
    async created() {
        this.$emit('emit-loaded-status', false);
        this.report_lang = this.$i18n.locale;
        this.company_name_input = this.listQuery.filters.company_name;
        this.reportFilterOpen = hasListFilters(REPORT_LIST_SPEC, this.listQuery.filters);
    },
    async mounted() {
        if (this.loadedRequiredData) {
            await this.getProjectReport();
            this.$emit('emit-loaded-status', true);
        }
    },
    beforeDestroy() {},
    methods: {
        ...mapMutations(['set_admin_mode', 'set_view_mode', 'update_question_composition']),
        ...mapMutations('questions', ['update_answer_company', 'update_subs', 'update_subs_loaded']),
        ...mapActions('reviews',['initiateReviews']),
        ...mapActions(['readTemplateTree', 'makeTemplateTreeByCompanyId']),
        ...mapMutations('attachments', ['initAttachmentsStorage']),
        ...mapActions('attachments', ['getAttatchments']),
        // 목록 상태를 URL 에 쓴다. 조건·표시 개수가 바뀌면 1페이지. URL 이 그대로면 false
        async navigateList (patch, method = 'push') {
            const _query = buildContractorListQuery(this.$route.query, REPORT_LIST_SPEC, {...this.listQuery, currentPage: 1, ...patch});
            if (isSameQuery(_query, this.$route.query)) return false;
            await this.$router[method]({ name: this.$route.name, params: this.$route.params, query: _query }).catch(() => {});
            return true;
        },
        // 조건 적용: 입력 중인 기업명도 함께 적용한다(선택 상자를 바꾸거나 Enter·검색 버튼)
        applyReportFilter (patch = {}) {
            return this.navigateList({filters: {...this.listQuery.filters, company_name: this.company_name_input, ...patch}});
        },
        // 검색 초기화: 입력·조건·페이지를 비운다(표시 개수는 유지)
        resetReportFilter () {
            this.company_name_input = null;
            this.reportFilterOpen = false;
            return this.navigateList({filters: {}, perPage: this.listQuery.perPage}, 'replace');
        },
        // URL 의 question_code 로 문항·답변을 불러온다. 늦게 온 이전 문항 응답이 최신 문항을 덮지 않도록 한 번에 하나씩
        async loadQuestionFromRoute () {
            if (this.question_loading) {
                this.question_reload = true;
                return;
            }
            this.question_loading = true;
            try {
                do {
                    this.question_reload = false;
                    await this.loadQuestion(this.$route.query.question_code || '');
                } while (this.question_reload);
            } finally {
                this.question_loading = false;
            }
        },
        async loadQuestion (_code) {
            this.subs_load_error = false;
            if (!_code) {
                this.update_question_composition(null);
                this.update_subs([]);
                this.update_subs_loaded(false);
                return;
            }
            // 뷰어가 준비되기 전이면 viewReport 가 끝에서 다시 부른다
            if (!this.view_target_report) return;

            this.update_subs_loaded(false);
            this.$store.commit('update_is_question_subs_loaded', false);
            try {
                await this.$store.dispatch('readQuestionComposition', _code);
                const { question_code, question_contents } = this.question_composition;
                await this.$store.dispatch('questions/readSubs', {
                    campaign_id: this.answer_company.campaign_id,
                    company_id: this.answer_company.company_id,
                    company_name: this.answer_company.company_name,
                    code: question_code,
                    contents: question_contents
                });
            } catch (error) {
                if (error?.response?.status === 401) return;
                this.subs_load_error = true;
            } finally {
                this.$store.commit('update_is_question_subs_loaded', true);
            }
        },
        // 에코바디스로 평가를 대체한 기업(보고서가 없어 목록에서 뺀다). 프로젝트마다 한 번만 조회한다
        async initEcovadisObj () {
            const _project_code = this.$route.query.projectid;
            if (this.ecovadis_by_project[_project_code]) return;
            const { data } = await this.$projectsAxios.get(`/participant/${_project_code}`, {
                params: { filter: 'search', condition: { status_code: ['eco_vadis'] } }
            });
            const _ecovadis = {};
            (data?.list || []).forEach(({ company_id }) => {
                _ecovadis[company_id] = true;
            });
            this.$set(this.ecovadis_by_project, _project_code, _ecovadis);
        },
        async getProjectReport () {
            const _seq = ++this.report_request_seq;
            const _project_code = this.$route.query.projectid;
            let _loaded = false;
            this.$emit('emit-loaded-status', false);
            try {
                this.is_loading_result_history = true;
                this.load_error = false;
                this.ecovadis_load_error = false;
                try {
                    await this.initEcovadisObj();
                } catch (error) {
                    if (error?.response?.status === 401) return;
                    console.error('[ContractorReport] initEcovadisObj error:', error);
                    if (_seq === this.report_request_seq) this.ecovadis_load_error = true;
                }
                const _ecovadis = this.ecovadis_by_project[_project_code] || {};
                const _res_project_report_history = await this.$axios('/report/history', {
                    params: { project_code: _project_code, with_alt: true, confirmed: 1 }
                });
                if (_seq !== this.report_request_seq) return;

                let _project_report = this.sortingCompanies(_res_project_report_history.data.result);
                if (!_project_report.length) {
                    _project_report = _project_report.reduce((_project_scoring, _company) => {
                        if (_company.scores) _company.scores = null;
                        _project_scoring.push(_company);
                        return _project_scoring;
                    }, []);
                } else {

                    const _company_id_list = _project_report.map(({ company_id }) => company_id);
                    const _company_list = new Set(_company_id_list);

                    _project_report = [..._company_list].reduce((_project_scoring, _company_id) => {
                        const _company_confirmed_reports = _project_report.filter(_report => _report.company_id === _company_id);
                        const {
                            id, project_code, campaign_id, campaign_name, company_id, company_name, requested_id, service_type, status_code, template_code, priority
                        } = _company_confirmed_reports[0].priority || _company_confirmed_reports[0];

                        if(_ecovadis[company_id]){ // ecovadis 제외
                            return _project_scoring;
                        }

                        _project_scoring[_company_id] = { id, project_code, campaign_id, campaign_name, company_id, company_name, requested_id, service_type, status_code, template_code, priority };

                        const _company_report_doc = _company_confirmed_reports.find(({ mode, priority }) => mode === 'DOC' || (priority && priority.mode === 'DOC'));
                        if (!_company_report_doc) {
                            _project_scoring[_company_id]['report_doc'] = null;
                        } else {

                            let { id, campaign_id, report_ext, report_key, report_name, report_path, time_stamp } = _company_report_doc.priority || _company_report_doc;
                            const _doc_lang_match = report_name?.match(this.lang_pattern);
                            _project_scoring[_company_id]['report_doc'] = {
                                report_history_id: id,
                                project_code, campaign_id, campaign_name, company_id, company_name, requested_id, service_type, status_code, template_code,
                                report_ext, report_key, report_name, report_path, time_stamp,
                                report_lang: _doc_lang_match?.length ? this.lang_pattern_pair[_doc_lang_match[0]] : 'ko',
                                has_multi_lang: !!_doc_lang_match?.length
                            };
                        }

                        if (service_type === '심화') {
                            const _company_report_osis = _company_confirmed_reports.find(({ mode, priority }) => mode === 'OSIS' || (priority && priority.mode === 'OSIS'));
                            if (_company_report_osis) {
                                const { id, campaign_id, report_ext, report_key, report_name, report_path, time_stamp } = _company_report_osis.priority || _company_report_osis;
                                const _osis_lang_match = report_name?.match(this.lang_pattern);
                                _project_scoring[_company_id]['report_osis'] = {
                                    report_history_id: id,
                                    project_code, campaign_id, campaign_name, company_id, company_name, requested_id, service_type, status_code, template_code,
                                    report_ext, report_key, report_name, report_path, time_stamp,
                                    report_lang: _osis_lang_match?.length ? this.lang_pattern_pair[_osis_lang_match[0]] : 'ko',
                                    has_multi_lang: !!_osis_lang_match?.length
                                };
                            }
                        }


                        return _project_scoring;
                    }, {});
                }

                this.result_history = Object.values(_project_report);
                _loaded = true;
            } catch (error) {
                console.error('[ContractorReport] getProjectReport error:', error);
                if (_seq !== this.report_request_seq || error?.response?.status === 401) return;
                this.result_history = [];
                this.load_error = true;
                this.$EventBus.$emit('toast-failure', this.$t('기업별 평가결과 현황'), this.$t('죄송합니다. 결과보고서를 불러오는 도중 장애가 발생했습니다. QESG info@qesg.co.kr 로 문의해주시기 바랍니다.'));
            } finally {
                if (_seq === this.report_request_seq) {
                    this.is_loading_result_history = false;
                    this.result_history_loaded = true;
                    this.$emit('emit-loaded-status', true);
                    // 공유 링크·새로고침의 뷰어 복원은 목록을 받은 뒤에만 (실패 때 뷰어 키를 지우면 다시 시도해도 복원되지 않는다)
                    if (_loaded) this.syncReportViewer();
                }
            }
        },
        // URL 의 report/rtype 으로 뷰어를 연다. 값은 신뢰하지 않고 조회된 목록에서만 찾는다
        syncReportViewer () {
            const { report, rtype } = this.$route.query;
            if (!report) {
                // 프로젝트 전환으로 view_target_report 가 먼저 비워져도 닫히도록 조건 없이 닫는다(닫혀 있으면 무시됨)
                this.$bvModal.hide('modal-report-viewer');
                return;
            }
            if (!this.result_history_loaded || this.is_viewing_report) return;
            const _report_type = rtype === 'osis' ? 'osis' : 'doc';
            if (this.view_target_report && String(this.view_target_report.company_id) === String(report) && this.view_target_report.report_type === _report_type) return;

            const _target = this.result_history.find(({ company_id }) => String(company_id) === String(report));
            if (_target && _target[`report_${_report_type}`]) {
                this.viewReport(_target, _report_type);
            } else {
                this.closeViewerQuery();
            }
        },
        // URL 이 아직 이 보고서를 가리키는지(불러오는 사이 뒤로가기 등으로 바뀌지 않았는지)
        isRequestedViewer (_company_id, _report_type) {
            const { report, rtype } = this.$route.query;
            return String(report) === String(_company_id) && (rtype === 'osis' ? 'osis' : 'doc') === _report_type;
        },
        // 뷰어 query 만 지운 현재 query (목록 조건·페이지는 남김)
        listOnlyQuery () {
            return Object.keys(this.$route.query).reduce((_query, key) => {
                if (!VIEWER_QUERY_KEYS.includes(key)) _query[key] = this.$route.query[key];
                return _query;
            }, {});
        },
        closeViewerQuery () {
            const _query = this.listOnlyQuery();
            if (isSameQuery(_query, this.$route.query)) return Promise.resolve();
            return this.$router.replace({ name: this.$route.name, params: this.$route.params, query: _query }).catch(() => {});
        },
        // 뷰어를 열기 전에 바꾼 화면 상태를 되돌린다(닫기·실패 공통)
        restoreListMode () {
            this.update_answer_company({});
            this.set_admin_mode('camp');
            this.set_view_mode('provider');
        },
        async viewReport (_report, _report_type) {
            const { project_code, campaign_id, campaign_name, company_id, company_name, template_code } = _report;
            const _selected_report = _report[`report_${_report_type}`];
            // 같은 기업이 이미 URL 에 있으면(새로고침·뒤로가기·링크 복원) 탭·문항을 살려 replace, 아니면 목록 조건 위에 새로 push
            const _restoring = String(this.$route.query.report) === String(company_id);
            const _query = {
                ...(_restoring ? this.$route.query : this.listOnlyQuery()),
                pc: project_code, cmp: campaign_id, cpn: company_id, cpnm: company_name,
                report: company_id, rtype: _report_type
            };
            let _reconcile = false;
            try {
                this.is_viewing_report = true;
                if (!_selected_report) throw new Error('Not_Found_Report_Data');
                // 뒤로가기·새로고침·링크 공유로 복원되도록 대상은 report/rtype 으로 기록 (pc/cmp/cpn/cpnm 은 답변보기 탭이 읽는다)
                if (!isSameQuery(_query, this.$route.query)) {
                    await this.$router[_restoring ? 'replace' : 'push']({ name: this.$route.name, params: this.$route.params, query: _query }).catch(() => {});
                }

                this.set_admin_mode('project');
                this.update_answer_company(_report);
                this.set_view_mode('user');
                await this.readTemplateTree({
                    template_code, company_id,
                    is_previous: false
                });
                await this.makeTemplateTreeByCompanyId({ campaign_id, company_id });

                // 불러오는 사이 URL 이 다른 보고서(또는 목록)로 바뀌었으면 이 보고서는 열지 않고 최신 URL 을 따른다
                if (!this.isRequestedViewer(company_id, _report_type)) {
                    _reconcile = true;
                    this.restoreListMode();
                    // 화면 상태를 되돌렸으니 열려 있던 뷰어도 처음부터 다시 맞춘다
                    this.view_target_report = null;
                    return;
                }

                const _view_target_report = {
                    project_code, campaign_name, company_id, company_name,
                    report_type: _report_type,
                    report: { ..._selected_report },
                    mode: 'view'
                };
                this.view_target_report = _view_target_report;

                this.$nextTick(() => {
                    if (this.view_target_report === _view_target_report) this.$bvModal.show('modal-report-viewer');
                });
                this.loadQuestionFromRoute();
            } catch (error) {
                this.restoreListMode();
                // 이미 다른 보고서를 요청한 뒤의 실패는 알리지 않고 최신 URL 을 따른다
                if (_selected_report && !this.isRequestedViewer(company_id, _report_type)) {
                    _reconcile = true;
                    this.view_target_report = null;
                    return;
                }
                await this.closeViewerQuery();
                if (error?.response?.status === 401) return;
                this.$EventBus.$emit('toast-failure', this.$t('결과보고서 보기'), this.$t('죄송합니다. 결과보고서를 불러오는 도중 장애가 발생했습니다. QESG info@qesg.co.kr 로 문의해주시기 바랍니다.'));
            } finally {
                this.is_viewing_report = false;
                if (_reconcile) this.syncReportViewer();
            }
        },
        // async downloadReport (_report, _company_id, _report_type) {
        // },
        // 닫기 시작(X·배경·Esc·URL 변경): 뷰어 키부터 지운다. 정리는 hidden 에서 이 뷰어에 한해 한다
        onHideReportViewer () {
            this.closing_report = this.view_target_report;
            this.closing_navigation = this.closeViewerQuery();
        },
        onHiddenRerportViewer () {
            const _closed = this.closing_report;
            this.closing_report = null;
            if (_closed?.report?.report_url) URL.revokeObjectURL(_closed.report.report_url);
            // 닫히는 사이 다른 보고서를 열기 시작했으면(빠른 뒤로·앞으로가기) 그 보고서의 상태는 건드리지 않는다
            if (this.is_viewing_report || this.view_target_report !== _closed) return;

            this.pdf_filename = null;
            this.needReport = false;
            this.reportData = { info: null, benchmarks: null, parser: null, risk: null, scoring: null };
            this.reportPDFLoadProgress = 0;
            this.reportPDFLoaded = false;
            this.view_target_report = null;
            this.report_lang = this.$i18n.locale;

            this.restoreListMode();
            this.update_subs_loaded(false);
            this.update_question_composition(null);
            // 닫히는 사이 앞으로가기 등으로 URL 이 다시 보고서를 가리키면 그 보고서를 연다
            Promise.resolve(this.closing_navigation).then(() => this.syncReportViewer());
        },
        // 첫 탭은 키 생략, 답변보기는 tab=answers (탭 전환은 replace)
        onReportTabInput (_index) {
            if (!this.$route.query.report || ![0, 1].includes(_index)) return;
            const _query = { ...this.$route.query };
            if (_index === 1) {
                _query.tab = 'answers';
            } else {
                delete _query.tab;
            }
            if (isSameQuery(_query, this.$route.query)) return;
            this.$router.replace({ name: this.$route.name, params: this.$route.params, query: _query }).catch(() => {});
        },
        onReportLoaded () {
            this.reportPDFLoaded = true;
        },
        onProgressReportLoad (onProgress) {
            this.reportPDFLoadProgress = (onProgress.loaded / onProgress.total) * 100;
        }
    },
};
</script>

<style scoped>
@media (min-width: 768px) {
    /* 모달 본문(머리글·탭·열 제목 제외 높이) 안에서 문항 목록과 답변이 각자 스크롤한다 */
    .report-answer-pane {
        max-height: calc(100vh - 260px);
        overflow-y: auto;
    }
}
</style>
